<template>
  <!--模态窗口中的内容-->
  <div
    ref="sampledata"
    id="sampledata"
    class="bringins-content"
    :class="{ 'emission-content-blue': styleType == 'typeBlue' }"
  >
    <div style="position: absolute; width: 100%; height: 100%">
      <div class="emission">
        <div
          class="emission-content"
          @click.stop="hideGovernVeido"
          :class="{ 'emission-content-green': styleType == 'typeGreen' }"
        >
          <el-tabs v-model="tabName" @tab-click="handleClick">
            <el-tab-pane label="基本信息" name="basicInfo">
              <div
                v-if="loading"
                :style="{ width: '100%', height: sampledataHeight + 'px' }"
              >
                <check-loading ref="checkLoading" v-if="loading"></check-loading>
              </div>
              <div v-else-if="!loading">
                <information
                  :informationData="informationData"
                  :height="sampledataHeight"
                  :inventoryName="inventoryName"
                ></information>
              </div>
            </el-tab-pane>
            <el-tab-pane label="排放源动态数据" name="emissionSource">
              <div
                v-if="loading2"
                :style="{ width: '100%', height: sampledataHeight + 'px' }"
              >
                <check-loading ref="checkLoading2" v-if="loading2"></check-loading>
              </div>
              <div
                v-if="!loading2"
                :style="{
                  width: '100%',
                  height: sampledataHeight - 100 + 'px',
                }"
              >
                <div
                  class="public-form form_box"
                  style="margin-bottom: 15px; position: relative; z-index: 10000"
                >
                  <el-form :inline="true">
                    <el-form-item label="起止时间">
<!--                      <el-date-picker
                        v-model="timeArr"
                        type="datetimerange"
                        range-separator="-"
                        :disabledDate="pickerOptions"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @change="date_change"
                      >
                        &lt;!&ndash; value-format="yyyy-MM-dd HH:mm"  &ndash;&gt;
                      </el-date-picker>-->
                      <DatePicker
                        :init-width="'420px'"
                        :start-time-str="timeArr[0]"
                        :end-time-str="timeArr[1]"
                        @dateChange="date_change"
                        :formatType="'YYYY-MM-DD HH:mm:ss'"
                        topPx="50px"
                        dateType="timerange"
                      >
                      </DatePicker>
                    </el-form-item>
                    <el-form-item>
                      <el-button @click="record_check_click">查询</el-button>
                      <el-button @click="record_reset_click">重置</el-button>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="record_box box" style="min-height: 280px">
                  <!-- 第一部分 -->
                  <template
                    v-for="(productItem, i) in productData"
                    v-bind:key="'product-' + i"
                  >
                    <div
                      class="infor_params_box jiance_params_box"
                      v-if="
                        productItem.startStopList !== undefined &&
                        productItem.startStopList.length > 0 &&
                        productOption[i] !== undefined &&
                        productOption[i].length > 0
                      "
                    >
                      <dl
                        class="item"
                        v-for="(item, j) in productOption[i]"
                        v-bind:key="j"
                      >
                        <dd>
                          <div class="title">
                            <img class="title-img" src="./img/icon_gear_default.png" />
                            <span class="equipType">生产设备-</span>
                            <span>{{ productOption[i][j].name }}-启停信号</span>
                          </div>
                          <chartLine6
                            ref="a"
                            v-if="item['finished'] && !isWeightSignal"
                            height="125px"
                            :options="productOption[i][j].options"
                          />
                          <chartLine5
                            ref="a"
                            v-if="item['finished'] && isWeightSignal"
                            height="220px"
                            :options="productOption[i][j].lineOptions"
                          />
                        </dd>
                      </dl>
                    </div>

                    <div
                      class="infor_params_box jiance_params_box"
                      v-if="
                        productItem.otherList !== undefined &&
                        productItem.otherList.length > 0 &&
                        productPowerOption[i] !== undefined &&
                        productPowerOption[i].length > 0 &&
                        !isWeightSignal
                      "
                    >
                      <dl
                        class="item"
                        v-for="(item, j) in productPowerOption[i]"
                        v-bind:key="j"
                      >
                        <dd style="padding: 0">
                          <div class="title">
                            <img class="title-img" src="./img/icon_gear_default.png" />
                            <span class="equipType">生产设备-</span>
                            <span>{{ productPowerOption[i][j].name }}</span>
                          </div>
                          <chartLine1
                            :ref="'a-' + i"
                            v-if="item['finished']"
                            height="220px"
                            :options="productPowerOption[i][j].lineOptions"
                          />
                        </dd>
                      </dl>
                    </div>

                    <div
                      class="infor_params_box jiance_params_box"
                      v-if="
                        productItem.valueList !== undefined &&
                        productItem.valueList.length > 0 &&
                        productValueOption[i] !== undefined &&
                        productValueOption[i].length > 0
                      "
                    >
                      <dl
                        class="item"
                        v-for="(item, j) in productValueOption[i]"
                        v-bind:key="j"
                      >
                        <dd style="padding: 0">
                          <div class="title">
                            <img class="title-img" src="./img/icon_gear_default.png" />
                            <span class="equipType">生产设备-</span>
                            <span>{{ productValueOption[i][j].name }}</span>
                          </div>
                          <div style="text-align: center">
                            <img
                              style="height: 200px; width: 400px; margin: auto"
                              :src="imgUrl[i + '-' + j]"
                              v-if="mediaType[i + '-' + j] === 'image'"
                            />
                            <video
                              style="height: 200px; width: 400px"
                              :src="imgUrl[i + '-' + j]"
                              muted="muted"
                              autoplay
                              loop="loop"
                              controls
                              v-else-if="mediaType[i + '-' + j] === 'video'"
                            ></video>
                          </div>
                          <chartLine4
                            :ref="'z-' + i"
                            v-if="item['finished']"
                            height="220px"
                            :options="productValueOption[i][j].lineOptions"
                            :x="i"
                            :y="j"
                          />
                        </dd>
                      </dl>
                    </div>
                  </template>

                  <!-- 第二部分 -->
                  <template
                    v-for="(governItem, i) in governData"
                    v-bind:key="'govern-' + i"
                  >
                    <div
                      class="infor_params_box jiance_params_box"
                      v-if="
                        governItem.startStopList !== undefined &&
                        governItem.startStopList.length > 0 &&
                        governOption[i] !== undefined &&
                        governOption[i].length > 0
                      "
                    >
                      <dl
                        class="item"
                        v-for="(item, j) in governOption[i]"
                        v-bind:key="'govern-' + j"
                      >
                        <dd>
                          <div class="title">
                            <img class="title-img" src="./img/icon_gear_default.png" />
                            <span class="equipType">治理设备-</span>
                            <span>{{ governOption[i][j].name }}-启停信号12</span>
                          </div>
                          <!-- <chartBarFog
                            :ref="'b-' + i + '-' + j"
                            v-if="item['finished'] && false"
                            height="135px"
                            @chartsBar2ClickEvent="chartsBar2ClickEvent"
                            :options="governOption[i][j].options"
                          /> -->
                          <chartLine6
                            :ref="'b-' + i + '-' + j"
                            v-if="item['finished'] && !isWeightSignal"
                            height="135px"
                            @chartsBar2ClickEvent="chartsBar2ClickEvent"
                            :options="governOption[i][j].options"
                          />
                        </dd>
                      </dl>
                    </div>

                    <div
                      class="infor_params_box jiance_params_box"
                      v-if="
                        governItem.otherList !== undefined &&
                        governItem.otherList.length > 0 &&
                        governPowerOption[i] !== undefined &&
                        governPowerOption[i].length > 0 &&
                        governPowerOptionCheck
                      "
                    >
                      <dl
                        class="item"
                        v-for="(item, j) in governPowerOption[i]"
                        v-bind:key="'governPower-' + j"
                      >
                        <dd style="padding: 0">
                          <div class="title">
                            <img class="title-img" src="./img/icon_gear_default.png" />
                            <span class="equipType">治理设备-</span>
                            <span>{{ governPowerOption[i][j].name }}</span>
                          </div>
                          <chartLine1
                            :ref="'b1-' + i"
                            v-if="item['finished']"
                            height="220px"
                            :options="governPowerOption[i][j].lineOptions"
                          />
                        </dd>
                      </dl>
                    </div>
                  </template>

                  <!-- 第三部分 -->
                  <template v-for="(tspItem, i) in beltTspData" v-bind:key="'tsp-' + i">
                    <div
                      class="infor_params_box jiance_params_box"
                      v-if="
                        tspItem.tsp !== undefined &&
                        tspItem.tsp.length > 0 &&
                        tspPowerOption[i] !== undefined &&
                        tspPowerOption[i].length > 0
                      "
                    >
                      <dl
                        v-for="(item, j) in tspPowerOption[i]"
                        v-bind:key="'tspPower-' + j"
                      >
                        <dd>
                          <div class="title">
                            <img class="title-img" src="./img/icon_gear_default.png" />
                            <!--span class="equipType">监测设备({{ tspItem.type }})-</span-->
                            <span class="equipType">{{ tspItem.deviceType }}-</span>
                            <span>{{ item.name }}</span>
                            <span
                              class="VDMButton"
                              v-if="tspItem.type == 'VDM'"
                              @click="toVDMList(tspItem.deviceNo)"
                              >查看VDM台账</span
                            >
                          </div>
                          <singleVdm
                            v-if="
                              item['finished'] &&
                              ((tspItem.type === 'VDM' && customerId != 46) ||
                                (queryDuring <= 24 * 3600 * 1000 &&
                                  customerId == 46 &&
                                  tspItem.type === 'VDM'))
                            "
                            :deviceNo="tspItem.deviceNo"
                            :startTime="timeArr[0]"
                            :endTime="timeArr[1]"
                          >
                          </singleVdm>
                          <chartLine3
                            :ref="'c-' + i + '-' + j"
                            v-if="
                              item['finished'] &&
                              (tspItem.type !== 'VDM' ||
                                (queryDuring > 24 * 3600 * 1000 && customerId == 46))
                            "
                            height="200px"
                            :options="item.options"
                          />
                        </dd>
                      </dl>
                    </div>
                  </template>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
          <fog-video
            class="video-wrap"
            v-if="showFogVideo"
            :obj="curGovernTimeValue"
          ></fog-video>
        </div>
      </div>
      <div class="return-btn" @click="returnFunc()">
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
import { unref, computed } from "vue";
import checkLoading from "@/modules/checkLoading";
import information from "./component/information/indexAutoVision.vue";
import fogVideo from "./component/fogVideo";
import { unwarp } from "@/utils/tools.js";

import chartBar2 from "@/modules/Charts/chartBar2";
import chartBarFog from "@/modules/Charts/chartBarFog";
import chartLine1 from "@/modules/Charts/chartLine1";
import chartLine3 from "@/modules/Charts/chartLine3";
import chartLine4 from "@/modules/Charts/chartLine4";
import chartLine5 from "@/modules/Charts/chartLine5";
import chartLine6 from "@/modules/Charts/chartLine6";

import singleVdm from "@/modules/unorganizedComponents/vdmBar/singleVdm.vue";

const tooltip = {
  formatter(params) {
    let str = "";
    str += `<div class="tooltip" style="background: #000;padding: 10px;font-size:20px!important;line-height:30px;">`;
    if (params[0].data[1] === 1) {
      //开
      str += `<div>时间：${params[0].data[0]}</div>`;
      str += `<div>启停信号：${params[0].seriesName}</div>`;
    } else if (params[2].data[1] === 1) {
      //无数据 (启 会被暂无数据遮住)
      str += `<div>时间：${params[0].data[0]}</div>`;
      str += `<div>启停信号：${params[2].seriesName}</div>`;
    } else {
      //停
      str += `<div>时间：${params[0].data[0]}</div>`;
      str += `<div>启停信号：${params[1].seriesName}</div>`;
    }
    str += `</div>`;
    //		params.forEach((item,i)=>{
    //			if()
    //			str+=`<div class="tooltip" style="font-size:30px;line-height:40px;">${item.name}：${item.value}</div>`
    //		})
    return str;
  },
};

const tooltip2 = {
  formatter(params) {
    let str = "";
    str += `<div class="tooltip" style="background: #000;padding: 10px;font-size:20px!important;line-height:30px;">`;
    if (params[2].data[1] === 1) {
      //无数据 (启 会被暂无数据遮住)
      str += `<div>时间：${params[2].data[0]}</div>`;
      str += `<div>启停信号：${params[2].seriesName}</div>`;
    } else if (params[0].data[0] === 1) {
      //开
      str += `<div>时间：${params[0].data[0]}</div>`;
      str += `<div>启停信号：${params[0].seriesName}</div>`;
    } else {
      //停
      str += `<div>时间：${params[1].data[0]}</div>`;
      str += `<div>启停信号：${params[1].seriesName}</div>`;
    }
    str += `</div>`;
    //		params.forEach((item,i)=>{
    //			if()
    //			str+=`<div class="tooltip" style="font-size:30px;line-height:40px;">${item.name}：${item.value}</div>`
    //		})
    return str;
  },
};

import { dateFormat } from "@/utils/tools.js";
import { mapState, mapGetters } from "vuex";
import iframePup from "@/modules/iframePup/iframePup.vue";
import { DatePicker } from "@/modules/commonDatePicker";
import { getEncryptWithPassword } from '@/utils/cryptoUtil.js';

export default {
  components: {
    DatePicker,
    checkLoading,
    information,
    chartBar2,
    chartBarFog,
    chartLine1,
    chartLine3,
    chartLine4,
    chartLine5,
    chartLine6,
    fogVideo,
    singleVdm,
  },
  data() {
    //这里存放数据
    return {
      customerId: this.$store.state.customerId,
      styleType: "",
      inventoryId: "",
      inventorySwitch: "",
      tabName: "basicInfo",
      loading: true,
      loading2: true,
      sampledataHeight: 200,
      informationData: {},
      productData: [],
      governData: [],
      beltTspData: [],
      productArgs: [],
      productOption: [],
      governArgs: [],
      governOption: [],
      governPowerOption: [],
      productValueOption: [],
      governPowerOptionCheck: true,
      productPowerOption: [],
      tspPowerOption: [],
      chartShowValid: false,
      allEmissionInventoryId: "",
      dutyInventoryId: "",
      inventoryName: "",
      dutyInventoryName: "",
      timeArr: [
        dateFormat("YYYY-mm-dd", new Date()) + " 00:00",
        dateFormat("YYYY-mm-dd HH:MM", new Date()),
      ],
      imgUrl: {},
      mediaType: {},
      isVdm: false,

      materialObj: {},

      allRenderData: [],
      curGovernTimeValue: {
        type: "", // 当前点击治理设备启停信号显示视频和图片url类型 1.视频 2.图片 3.未知
        url: "", // // 当前点击治理设备启停信号显示视频和图片url
      },
      showFogVideo: false,

      vdmTspUnit: "mg/m³",

      queryDuring: 0,

      isWeightSignal: false,
      // scrollTop: "",
      // scrollview: ""
    };
  },
  inject: ["getDutyInventoryId"],
  provide: function () {
    return {
      //getImgUrl: computed(() => this.imgUrl),
      updateImgUrl: this.updateImgUrl,

      //getMediaType: computed(() => this.mediaType),
      updateMediaType: this.updateMediaType,
    };
  },
  //计算属性 类似于data概念
  computed: {
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
    getDeviceTabs() {
      return this.$store.state.deviceBarTabs;
    },
  },
  //监控data中的数据变化
  watch: {
    getInventoryId: {
      handler(newVal, oldVal) {
        let that = this;
        let inventoryObj = unref(newVal);
        this.inventorySwitch = inventoryObj.inventoryId;
        this.inventoryId = inventoryObj.inventoryId;
        this.inventoryName = inventoryObj.inventoryName;
        this.inventoryBar = inventoryObj.inventoryBar;
        if (this.inventoryBar == "2") {
          this.tabName = "emissionSource";
        } else {
          this.tabName = "basicInfo";
        }
        if (this.inventorySwitch) {
          this.$nextTick(() => {
            this.changeBringins();
            $(".bringins-block").css("left", "initial");
          });
        }
      },
      deep: true,
    },
    getInventoryName: {
      handler(newVal, oldVal) {
        this.inventoryName = unref(newVal);
        this.$forceUpdate();
      },
      deep: true,
    },
    getInventorySwitch: {
      handler(newVal, oldVal) {
        let that = this;
        this.inventorySwitch = unref(newVal);
        if (this.inventorySwitch) {
          this.$nextTick(() => {
            this.changeBringins();
          });
        } else {
          if (this.changeBringinsTimer) {
            clearTimeout(this.changeBringinsTimer);
          }
          //$(this.$refs.sampledata).hide();
          $(".bringins-block").fadeOut(500);
        }
      },
      deep: true,
    },
    getAllEmissionInventoryId: {
      handler(newVal, oldVal) {
        let that = this;
        let shedObj = unref(newVal);
        this.allEmissionInventoryId = shedObj.inventoryId;
        this.inventoryName = shedObj.inventoryName;
        if (this.allEmissionInventoryId) {
          this.$nextTick(() => {
            this.changeBringins();
          });
        }
      },
      deep: true,
    },
    getAllEmissionInventoryName: {
      handler(newVal, oldVal) {
        let that = this;
        this.inventoryName = unref(newVal);
      },
      deep: true,
    },
    getDutyInventoryId: {
      handler(newVal, oldVal) {
        let that = this;
        let dutyObj = unref(newVal);
        this.dutyInventoryId = dutyObj.inventoryId;
        this.inventoryId = dutyObj.inventoryId;
        this.inventorySwitch = dutyObj.inventoryId;
        //this.inventoryId = dutyObj.inventoryId;
        this.inventoryName = dutyObj.inventoryName;
        this.inventoryBar = dutyObj.inventoryBar;
        if (this.dutyInventoryId) {
          this.$nextTick(() => {
            this.changeBringins();
            if (this.inventoryBar == "2" && this.tabName != "emissionSource") {
              setTimeout(() => {
                this.tabName = "emissionSource";
                this.handleClick({ paneName: "emissionSource" });
              }, 500);
            } else if (this.inventoryBar != "2" && this.tabName != "basicInfo") {
              setTimeout(() => {
                this.tabName = "basicInfo";
                this.handleClick({ paneName: "basicInfo" });
              }, 500);
            }
          });
        }
      },
      deep: true,
    },
    getDutyInventoryName: {
      handler(newVal, oldVal) {
        let that = this;
        this.inventoryName = unref(newVal);
      },
      deep: true,
    },
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
      },
      deep: true,
    },
    getAllEmissionVdmId: {
      handler(newVal, oldVal) {
        let that = this;
        let shedObj = unref(newVal);
        this.allEmissionInventoryId = shedObj.inventoryId;
        this.shedId = shedObj.shedId;
        this.inventoryName = shedObj.shedName;
        this.materialObj = {
          shedNo: this.shedId,
          shedName: shedObj.shedName,
        };

        if (this.allEmissionInventoryId) {
          if (this.changeBringinsTimer) {
            clearTimeout(this.changeBringinsTimer);
          }
          this.changeBringinsTimer = setTimeout(function () {
            that.changeBringins();
            //$(".allEmissionResource").find(".bringins-block").css("left", "0");
          }, 50);
        }
      },
      deep: true,
    },
    getAllEmissionVdmName: {
      handler(newVal, oldVal) {
        this.shedName = unref(newVal);
      },
      deep: true,
    },
    getDeviceTabs: {
      handler(newVal, oldVal) {
        this.tabName = newVal;
      },
      deep: true,
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.styleType = bmeConfig.styleType;
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    $(this.$refs.sampledata).hide();

    this.timeArr = [
      dateFormat("YYYY-mm-dd HH:MM", new Date().getTime() - 24 * 3600 * 1000),
      dateFormat("YYYY-mm-dd HH:MM", new Date()),
    ];

    this.tabName = this.getDeviceTabsStore();
    this.$forceUpdate();
  },
  //方法集合
  methods: {
    pickerOptions(time) {
      if (this.customerId == 1414) {
        return (
          time.getTime() > new Date().getTime() ||
          new Date("2021-07-01 00:00:00").getTime() > time.getTime()
        );
      } else {
        return time.getTime() > new Date().getTime();
      }
    },
    updateMediaType(val, i, j) {
      this.mediaType[i + "-" + j] = val;
    },
    updateImgUrl(val, i, j) {
      this.imgUrl[i + "-" + j] = val;
    },
    getDeviceTabsStore() {
      return this.$store.state.deviceBarTabs;
    },
    /* this.pidaiData = [{
         value: this.datas.startStopList ? this.datas.startStopList : [],
         productName: this.datas.deviceType + "-" + this.datas.deviceName,
         dType: _this.datas.deviceType,
         dName: _this.datas.deviceName,
      }];
    this.formatPidai(this.pidaiData);*/
    record_check_click() {
      let that = this;
      this.getAjaxResult();
    },
    record_reset_click() {
      let that = this;
      this.timeArr = [
        dateFormat("YYYY-mm-dd HH:MM", new Date().getTime() - 24 * 3600 * 1000),
        dateFormat("YYYY-mm-dd HH:MM", new Date()),
      ];
      this.getAjaxResult();
    },
    date_change(e) {
      this.timeArr = e;
    },
    formatProduct(data, i) {
      let that = this;
      let tempResult = [];

      if (!this.isWeightSignal) {
        if (data.startStopList && data.startStopList.length > 0) {
          data.startStopList.forEach((item) => {
            tempResult.push({
              value: item["valueList"] ? item["valueList"] : [],
              productName:
                data["deviceName"] +
                (item["valueName"] ? " (" + item["valueName"] + ")" : ""),
            });
          });
        }
        this.productArgs[i] = tempResult.map(
          ({ productName: name, value, dType, dName }) => {
            let xdata = [],
              ydata = [[], [], []];
            dType = dType ? dType : "";
            dName = dName ? dName : "";
            value.forEach(({ dataTime, time, value }) => {
              xdata.push(
                time != null ? time : that.$moment(dataTime).format("YYYY-MM-DD HH:mm")
              );
              ydata[1].push({ value: value > 0 ? 1 : 0 }); //启 会被暂无数据遮住
              ydata[0].push({ value: 1 }); //停 用于离线
              ydata[2].push({ value: value === null ? 1 : 0 }); //用于显示暂无数据
            });
            return {
              dType,
              dName,
              name,
              options: {
                tooltip: tooltip2,
                xdata,
                ydata,
                name,
                isTime: true,
                themeName: "product",
              },
            };
          }
        );
        this.productOption[i] = this.productArgs[i];
        this.productOption[i] &&
          this.productOption[i].forEach((item) => {
            this.allRenderData.push(item);
          });
        //this.$forceUpdate();
      } else {
        if (data.startStopList && data.startStopList.length > 0) {
          tempResult.push({
            value: data.startStopList ? data.startStopList : [],
            productName: data["deviceName"],
          });
        }
        let argsObj = tempResult.map(({ productName: name, value, dType, dName }) => {
          let xdata = [];
          let lineYdata = [];
          value[0].valueList.forEach((x, i) => {
            xdata.push(
              x.time != null
                ? x.time
                : that.$moment(x.dataTime).format("YYYY-MM-DD HH:mm")
            );
          });
          value.forEach(({ valueName, valueType, valueList, unit }) => {
            let sData = { name: valueName, data: [] };
            valueList.forEach((x, i) => {
              //						xdata.push(x.time);
              if (x.value === null) {
                x.value = "";
              }
              let sObj = { value: x.value, unit: unit };
              sData.data.push(sObj);
            });
            lineYdata.push(sData);
          });

          // line tooltip 配置
          let toolTipLine = {
            formatter(params) {
              let str = "";
              str += `<div class="tooltip" style="background: #000;padding: 10px;font-size:20px!important;line-height:30px;">`;
              str += `<div>时间：${params[0].data[0]}</div>`;
              params.forEach((item) => {
                let value =
                  item.data[1] === "" ? "暂无数据" : item.data[1] === 0 ? "停" : "启动";
                let unit = item.value === "" ? "" : item.data.unit;
                str += `<div>
								${item.seriesName}：${value}
							</div>`;
              });
              str += `</div>`;
              return str;
            },
          };
          let xAxis = {
            axisLabel: {
              align: "left",
              color: "#A6CAFF",
              fontSize: 18,
              formatter: "{MM}-{dd} {HH}:{mm}",
              //interval: xdata.length / 8,
            },
          };
          let grid = {
            right: "5%",
          };
          return {
            dType,
            dName,
            name: name,
            lineOptions: {
              name: name,
              tooltip: toolTipLine,
              xAxis,
              grid,
              xdata,
              ydata: lineYdata,
              themeName: "productPower",
              isTime: true,
            },
          };
        });
        this.productOption[i] = argsObj;
        console.log(argsObj);
        this.productOption[i] &&
          this.productOption[i].forEach((item) => {
            this.allRenderData.push(item);
          });
      }
    },

    formatProductPower(data, i) {
      let that = this;
      let tempResult = [];
      if (data.otherList && data.otherList.length > 0) {
        tempResult.push({
          value: data.otherList ? data.otherList : [],
          productName: data["deviceName"],
        });
        data.otherList.forEach((item) => {
          if (
            (item.valueName === "称重" && this.customerId == 30) ||
            (item.valueName === "重量" && this.customerId == 38)
          ) {
            this.isWeightSignal = true;
          }
        });
      }
      let argsObj = tempResult.map(({ productName: name, value, dType, dName }) => {
        let xdata = [];
        let lineYdata = [];
        value[0].valueList.forEach((x, i) => {
          xdata.push(
            x.time != null ? x.time : that.$moment(x.dataTime).format("YYYY-MM-DD HH:mm")
          );
        });
        value.forEach(({ valueName, valueType, valueList, unit }) => {
          let sData = { name: valueName, data: [] };
          valueList.forEach((x, i) => {
            //						xdata.push(x.time);
            if (x.value === null) {
              x.value = "";
            }
            let sObj = { value: x.value, unit: unit };
            sData.data.push(sObj);
          });
          lineYdata.push(sData);
        });

        // line tooltip 配置
        let toolTipLine = {
          formatter(params) {
            let str = "";
            str += `<div class="tooltip" style="background: #000;padding: 10px;font-size:20px!important;line-height:30px;">`;
            str += `<div>时间：${params[0].data[0]}</div>`;
            params.forEach((item) => {
              let value = item.value === "" ? "暂无数据" : item.data[1];
              let unit = item.value === "" ? "" : item.data[2];
              str += `<div>
								${item.seriesName}：${value}${unit}
							</div>`;
            });
            str += `</div>`;
            return str;
          },
        };
        let xAxis = {
          axisLabel: {
            align: "left",
            color: "#A6CAFF",
            fontSize: 18,
            formatter: "{MM}-{dd} {HH}:{mm}",
            //interval: xdata.length / 8,
          },
        };
        let grid = {
          right: "5%",
        };
        return {
          dType,
          dName,
          name: name,
          lineOptions: {
            name: name,
            tooltip: toolTipLine,
            xAxis,
            grid,
            xdata,
            ydata: lineYdata,
            themeName: "productPower",
            isTime: true,
          },
        };
      });
      this.productPowerOption[i] = argsObj;
      this.productPowerOption[i] &&
        this.productPowerOption[i].forEach((item) => {
          this.allRenderData.push(item);
        });
      //this.$forceUpdate();
    },
    formatProductVal(data, i) {
      let that = this;
      let tempResult = [];
      if (data.valueList && data.valueList.length > 0) {
        tempResult.push({
          value: data.valueList ? data.valueList : [],
          productName: data["deviceName"],
        });
      }
      let argsObj = tempResult.map(({ productName: name, value, dType, dName }) => {
        let xdata = [];
        let lineYdata = [];
        /*value[0].valueList.forEach((x, i) => {
            xdata.push(
              x.time != null
                ? x.time
                : that.$moment(x.dataTime).format("MM-DD HH:mm")
            );
          });*/
        let sData = { name: "报警事件", data: [] };
        value.forEach((item) => {
          xdata.push(
            item.time != null
              ? item.time
              : that.$moment(item.dataTime).format("YYYY-mm-dd HH:MM")
          );
          let sObj = { value: 100, unit: "", url: item.value };
          sData.data.push(sObj);
        });
        lineYdata.push(sData);

        // line tooltip 配置
        let toolTipLine = {
          formatter(params) {
            let str = "";
            str += `<div class="tooltip" style="background: #000;padding: 10px;font-size:20px!important;line-height:30px;">`;
            str += `<div>时间：${params[0].data[0]}</div>`;
            params.forEach((item) => {
              let value = item.value === "" ? "暂无数据" : item.data[1];
              let unit = item.value === "" ? "" : item.data[2];
              str += `<div>
								${item.seriesName}：${value}${unit}
							</div>`;
            });
            str += `</div>`;
            return str;
          },
        };
        let xAxis = {
          axisLabel: {
            align: "left",
            color: "#A6CAFF",
            fontSize: 18,
            formatter: "{MM}-{dd} {HH}:{mm}",
            //interval: xdata.length / 8,
          },
        };
        let yAxis = {};
        let grid = {
          right: "5%",
        };
        return {
          dType,
          dName,
          name: name,
          lineOptions: {
            name: name,
            tooltip: toolTipLine,
            xAxis,
            grid,
            xdata,
            ydata: lineYdata,
            themeName: "productPower",
            isTime: true,
          },
        };
      });
      this.productValueOption[i] = argsObj;
      this.productValueOption[i] &&
        this.productValueOption[i].forEach((item) => {
          this.allRenderData.push(item);
        });
      //this.$forceUpdate();
    },
    // 格式化除尘器启停数据
    formatGovern(data, i) {
      let that = this;
      let tempResult = [];
      if (data.startStopList && data.startStopList.length > 0) {
        tempResult.push({
          value: data.startStopList[0]["valueList"]
            ? data.startStopList[0]["valueList"]
            : [],
          productName: data["deviceName"],
        });
      }
      this.governArgs[i] = tempResult.map(
        ({ productName: name, value, dType, dName }) => {
          let xdata = [],
            ydata = [[], [], []];
          dType = dType ? dType : "";
          dName = dName ? dName : "";
          value.forEach(({ dataTime, time, value }) => {
            xdata.push(
              time != null ? time : that.$moment(dataTime).format("yyyy-MM-DD HH:mm")
            );
            ydata[0].push({ value: 1 }); //用于离线
            ydata[1].push({ value: value ? 1 : 0 }); //启 会被暂无数据遮住
            if (value === null) {
              ydata[2].push({ value: 1 }); //用于显示暂无数据
            } else {
              ydata[2].push({ value: 0 });
            }
          });
          return {
            dType,
            dName,
            name,
            options: {
              tooltip: tooltip2,
              xdata,
              ydata,
              name,
              themeName: "govern",
              deviceNo: data.deviceNo,
              isTime: true,
            },
          };
        }
      );
      this.governOption[i] = this.governArgs[i];
      this.governOption[i] &&
        this.governOption[i].forEach((item) => {
          this.allRenderData.push(item);
        });
      //this.$forceUpdate();
    },
    formatGovernPower(data, i) {
      let that = this;
      let tempResult = [];
      //this.governPowerOptionCheck = false;
      if (data.otherList && data.otherList.length > 0) {
        tempResult.push({
          value: data.otherList ? data.otherList : [],
          productName: data["deviceName"],
        });
      }
      let argsObj = tempResult.map(({ productName: name, value, dType, dName }) => {
        let xdata = [];
        let lineYdata = [];
        value[0].valueList.forEach((x, i) => {
          xdata.push(
            x.time != null ? x.time : that.$moment(x.dataTime).format("YYYY-MM-DD HH:mm")
          );
        });
        value.forEach(({ valueName, valueType, valueList, unit }) => {
          let sData = { name: valueName, data: [] };
          valueList.forEach((x, i) => {
            //						xdata.push(x.time);
            if (x.value === null) {
              x.value = "";
            }
            let sObj = { value: x.value, unit: unit };
            sData.data.push(sObj);
          });
          lineYdata.push(sData);
        });

        /*try {
          lineYdata.forEach((item) => {
            item.data.forEach((item_) => {
              if (item_) {
                that.governPowerOptionCheck = true;
                throw Error("need to render");
              }
            });
          });
        } catch (err) {
          console.log(err);
        }*/

        // line tooltip 配置
        let toolTipLine = {
          formatter(params) {
            let str = "";
            str += `<div class="tooltip" style="background: #000;padding: 10px;font-size:20px!important;line-height:30px;">`;
            str += `<div>时间：${params[0].data[0]}</div>`;
            params.forEach((item) => {
              let value = item.value === "" ? "暂无数据" : item.data[1];
              let unit = item.value === "" ? "" : item.data[2];
              str += `<div>
								${item.seriesName}：${value}${unit}
							</div>`;
            });
            str += `</div>`;
            return str;
          },
        };
        let xAxis = {
          axisLabel: {
            align: "left",
            color: "#A6CAFF",
            fontSize: 18,
            formatter: "{MM}-{dd} {HH}:{mm}",
            //interval: xdata.length / 8,
          },
        };
        let grid = {
          right: "5%",
        };
        return {
          dType,
          dName,
          name: name,
          lineOptions: {
            name: name,
            tooltip: toolTipLine,
            xAxis,
            grid,
            xdata,
            ydata: lineYdata,
            themeName: "governPower",
            isTime: true,
          },
        };
      });
      this.governPowerOption[i] = argsObj;
      this.governPowerOption[i] &&
        this.governPowerOption[i].forEach((item) => {
          this.allRenderData.push(item);
        });
      //this.$forceUpdate();
    },
    formatTps(data, i) {
      let that = this;
      let tempResult = [];
      let unit = data.unit ? data.unit : "mg/m³";
      if (data.tsp && data.tsp.length > 0) {
        tempResult.push({
          value: data.tsp ? data.tsp : [],
          productName: data["deviceName"],
        });
      }
      let argsObj = tempResult.map(({ productName: name, value, dType, dName }) => {
        let xdata = [],
          ydata = [];

        value.forEach(({ dataTime, dateTime, time, value }) => {
          xdata.push(
            time != null
              ? time
              : that.$moment(dataTime ? dataTime : dateTime).format("YYYY-MM-DD HH:mm")
          );
          if (value === null) {
            value = "";
          }
          value = value ? (!isNaN(value) ? value : value.toFixed(2)) : "0";
          ydata.push(value);
        });
        let alertLine =
          data.deviceType && data.deviceType.indexOf("含水率") >= 0
            ? 0
            : unit == "μg/m³" || unit == "ug/m3" || unit == "μg/m3" || unit == "ug/m³"
            ? 2000
            : 2; // 警戒线：2 mg/m³
        let labelName =
          data.deviceType && data.deviceType.indexOf("含水率") >= 0
            ? ""
            : `警戒线：${alertLine} ` + unit;
        let yAxis = {
          max: function (value) {
            if (value.max > 2) {
              return Math.ceil(value.max);
            } else {
              return Math.ceil(2);
            }
          },
        };
        let toolTipLine = {
          formatter(params) {
            let str = "";
            str += `<div class="tooltip" style="background: #000;padding: 10px;font-size:20px!important;line-height:30px;">`;
            str += `<div>时间：${params[0].data[0]}</div>`;
            params.forEach((item) => {
              let value = item.value === "" ? "暂无数据" : item.value[1];
              let unit = item.value === "" ? "" : data.unit ? data.unit : "mg/m³";
              str += `<div>
								${
                  data.deviceType && data.deviceType.indexOf("含水率") >= 0
                    ? "含水率"
                    : "TSP"
                }：${value} ${unit}
							</div>`;
            });
            str += `</div>`;
            return str;
          },
        };
        let xAxis = {
          axisLabel: {
            align: "left",
            color: "#A6CAFF",
            fontSize: 18,
            formatter: "{MM}-{dd} {HH}:{mm}",
            //interval: xdata.length / 8,
          },
        };
        return {
          dType,
          dName,
          name,
          xAxis,
          //					options:{xdata,ydata,name:name,alertLine,labelName,yAxis}
          options: {
            xdata,
            ydata,
            name: name,
            tooltip: toolTipLine,
            alertLine,
            labelName,
            yAxis,
            isTime: true,
          },
          themeName: "tps",
        };
      });
      this.tspPowerOption[i] = argsObj;
      this.tspPowerOption[i] &&
        this.tspPowerOption[i].forEach((item) => {
          this.allRenderData.push(item);
        });
      //this.$forceUpdate();
    },
    handleClick: function (tab, event) {
      if (tab.paneName == "emissionSource") {
        let that = this;
        //this.getDynamicsEmissionSource();
        this.getAjaxResult();
      } else if (tab.paneName == "basicInfo") {
        this.getDeviceDetail(
          this.inventoryId ? this.inventoryId : this.allEmissionInventoryId
        );
      }
      this.$store.commit("changeDeviceTabs", tab.paneName);
    },
    connectEchart(isH) {
      let that = this;
      return new Promise((resolve) => {
        setTimeout(() => {
          let connectCharts = [];
          getChilds(that);
          function getChilds(item) {
            if (item.$refs) {
              for (let key in item.$refs) {
                if (key && key.indexOf("z-") < 0) {
                  if (
                    item.$refs[key] &&
                    item.$refs[key].length &&
                    item.$refs[key].length > 0
                  ) {
                    item.$refs[key].forEach((tmpItem) => {
                      if (tmpItem && tmpItem.getChart) {
                        connectCharts.push(tmpItem.getChart());
                      }
                    });
                  } else {
                    if (item.$refs[key] && item.$refs[key].getChart) {
                      connectCharts.push(item.$refs[key].getChart());
                    }
                  }
                }
              }
            }
          }
          //console.log(connectCharts);
          //过滤没用的图表
          connectCharts = connectCharts.filter((e) => e);
          if (!connectCharts.length) return;
          echarts.connect(connectCharts);
          // resolve( connectCharts);
        }, 1000);
      });
    },
    connectChart() {
      let that = this;
      return new Promise((resolve) => {
        setTimeout(() => {
          try {
            let connectCharts = [];

            getChilds(that);
            function getChilds(item) {
              if (item.$refs) {
                for (let key in item.$refs) {
                  if (key && key.indexOf("z-") < 0) {
                    if (
                      item.$refs[key] &&
                      item.$refs[key].length &&
                      item.$refs[key].length > 0
                    ) {
                      item.$refs[key].forEach((tmpItem) => {
                        if (tmpItem && tmpItem.getChart) {
                          connectCharts.push(tmpItem.getChart());
                        }
                      });
                    } else {
                      if (item.$refs[key] && item.$refs[key].getChart) {
                        connectCharts.push(item.$refs[key].getChart());
                      }
                    }
                  }
                }
              }
            }

            connectCharts.forEach((item) => {
              item.off("showTip");
              item.off("globalout");
              item.on("globalout", function () {
                connectCharts.forEach((item_) => {
                  item_.dispatchAction({
                    type: "hideTip",
                  });
                });
              });
              item.on("showTip", function (e) {
                bindToolTip(this, e);
              });
            });

            function bindToolTip(that, e) {
              // console.log(e);
              if (window.echartTimer) {
                clearTimeout(window.echartTimer);
              }

              window.echartTimer = setTimeout(() => {
                if (!e.dataIndex && e.dataIndex !== 0) {
                  connectCharts.forEach((item_) => {
                    item_.dispatchAction({
                      type: "hideTip",
                    });
                  });
                  return;
                }
                let compareOption = that.getOption();
                let compareName = compareOption.xAxis[0].data[e.dataIndex];
                // console.log(compareName);
                if (!compareName) {
                  connectCharts.forEach((item_) => {
                    item_.dispatchAction({
                      type: "hideTip",
                    });
                  });
                  return;
                }
                let compareT = new Date(compareName).getTime();
                connectCharts.forEach((item_) => {
                  if (item_.id != that.id) {
                    let option = item_.getOption();
                    let xAxisList = option.xAxis[0].data;
                    let tmpIndex = 0;
                    for (let c = 0; c < xAxisList.length - 1; c++) {
                      if (
                        new Date(xAxisList[c]).getTime() <= compareT &&
                        new Date(xAxisList[c + 1]).getTime() > compareT
                      ) {
                        tmpIndex = c;
                        break;
                      }
                    }
                    // console.log(tmpIndex);
                    item_.off("showTip");
                    if (
                      option.yAxis &&
                      option.yAxis[0] &&
                      option.yAxis[0]["data"] &&
                      option.yAxis[0]["data"].length == 2 &&
                      option.yAxis[0]["data"][0] === 0 &&
                      option.yAxis[0]["data"][1] === 1
                    ) {
                      item_.dispatchAction({
                        type: "showTip",
                        seriesIndex: 0,
                        dataIndex: tmpIndex,
                      });
                      item_.dispatchAction({
                        type: "showTip",
                        seriesIndex: 1,
                        dataIndex: tmpIndex,
                      });
                    } else {
                      item_.dispatchAction({
                        type: "showTip",
                        seriesIndex: 0,
                        dataIndex: tmpIndex,
                      });
                    }

                    item_.on("showTip", function (e) {
                      bindToolTip(this, e);
                    });
                  }
                });
              }, 50);
            }
          } catch (err) {
            console.log(err);
          }
        }, 0);
      });
    },
    async getDynamicsEmissionSource() {
      this.chartShowValid = false;
      this.loading2 = true;

      //this.productData = await this.findRelationProductionList();
      let productData = await this.findRelationProductionList();
      /*if (this.customerId === 38) {
        this.productData = productData;
      } else {
        this.productData = [productData];
      }*/
      this.productData = [productData];
      let governData = await this.findRelationGovernment();
      /*if (this.customerId === 38) {
        this.governData = governData;
      } else {
        this.governData = [governData];
      }*/
      this.governData = [governData];
      let beltTspData = await this.getBeltDynamicTsp();

      if (beltTspData && beltTspData.length) {
        this.vdmTspUnit =
          beltTspData[0] && beltTspData[0].unit ? beltTspData[0].unit : "mg/m³";
      }

      /*if (this.customerId === 38) {
        this.beltTspData = beltTspData;
      } else {
        this.beltTspData = [beltTspData];
      }*/
      this.beltTspData = [beltTspData];
      if (bmeConfig.customizeEchartConnect) {
        this.connectChart();
      } else {
        this.connectEchart();
      }

      return {
        productData: this.productData,
        governData: this.governData,
        beltTspData: this.beltTspData,
      };
    },
    //生产设备
    async findRelationProductionList() {
      /*let findRelationProductionListUrl =
        CONFIG.requestName +
        (this.customerId === 38
          ? this.$apiOpt.findRelationProductionListNew
          : this.$apiOpt.findRelationProductionList);*/
      let findRelationProductionListUrl =
        CONFIG.requestName + this.$apiOpt.findRelationProductionListAutoVision;
      return this.$apiUtils.get(findRelationProductionListUrl, {
        inventoryId: this.inventoryId ? this.inventoryId : this.allEmissionInventoryId,
        startTime: this.timeArr[0]
          ? this.timeArr[0]
          : this.$moment(new Date().getTime() - 24 * 3600 * 1000).format(
              "YYYY-MM-DD HH:mm"
            ),
        endTime: this.timeArr[1]
          ? this.timeArr[1]
          : this.$moment().format("YYYY-MM-DD HH:mm"),
      });
    },
    //治理设备
    async findRelationGovernment() {
      /*let findRelationGovernmentUrl =
        CONFIG.requestName +
        (this.customerId === 38
          ? this.$apiOpt.findRelationGovernmentNew
          : this.$apiOpt.findRelationGovernment);*/
      let findRelationGovernmentUrl =
        CONFIG.requestName + this.$apiOpt.findRelationGovernmentAutoVision;
      return this.$apiUtils.get(findRelationGovernmentUrl, {
        inventoryId: this.inventoryId ? this.inventoryId : this.allEmissionInventoryId,
        startTime: this.timeArr[0]
          ? this.timeArr[0]
          : this.$moment(new Date().getTime() - 24 * 3600 * 1000).format(
              "YYYY-MM-DD HH:mm"
            ),
        endTime: this.timeArr[1]
          ? this.timeArr[1]
          : this.$moment().format("YYYY-MM-DD HH:mm"),
      });
    },
    //监测设备
    async getBeltDynamicTsp() {
      /*let getBeltDynamicTspUrl =
        CONFIG.requestName +
        (this.customerId === 38
          ? this.$apiOpt.getBeltDynamicTspNew
          : this.$apiOpt.getBeltDynamicTsp);*/

      let startTime = this.timeArr[0]
        ? this.timeArr[0] + ":00"
        : this.$moment(new Date().getTime() - 24 * 3600 * 1000).format(
            "YYYY-MM-DD HH:mm:ss"
          );
      let endTime = this.timeArr[1]
        ? this.timeArr[1] + ":00"
        : this.$moment().format("YYYY-MM-DD HH:mm:ss");
      this.queryDuring = new Date(endTime).getTime() - new Date(startTime).getTime();
      // console.log(this.queryDuring);
      let getBeltDynamicTspUrl =
        CONFIG.requestName + this.$apiOpt.getBeltDynamicTspAutoVision;
      return this.$apiUtils.get(getBeltDynamicTspUrl, {
        inventoryId: this.inventoryId ? this.inventoryId : this.allEmissionInventoryId,
        startTime: startTime,
        endTime: endTime,
      });
    },
    //获取设备详情
    getDeviceDetail(inventoryId) {
      let that = this;
      this.loading = true;
      let getBeltUrl = CONFIG.requestName + this.$apiOpt.findEmissionDeviceBasic;
      this.$apiUtils
        .get(getBeltUrl, {
          id: this.inventoryId ? this.inventoryId : this.allEmissionInventoryId,
        })
        .then(function (data) {
          that.loading = false;
          let newData = {
            production: [],
            government: [],
            monitoring: [],
            staticProductionName: "",
          };
          if (data && data.production && data.production.length > 0) {
            newData.staticProductionName = data.production[0]["deviceName"];
            data.production.forEach((item) => {
              newData.production.push({
                name: item.deviceName,
                value: item.deviceInfo,
              });
            });
          }
          if (data && data.governmen && data.governmen.length > 0) {
            data.governmen.forEach((item) => {
              let tmpVal = [];
              for (let i in item.deviceInfo) {
                tmpVal.push({
                  name: i,
                  value: item.deviceInfo[i],
                });
              }
              newData.government.push({
                deviceName: item.deviceName,
                valueList: tmpVal,
              });
            });
          }
          if (data && data.monitor && data.monitor.length > 0) {
            data.monitor.forEach((item) => {
              let tmpVal = [];
              for (let i in item.deviceInfo) {
                tmpVal.push({
                  name: i,
                  value: item.deviceInfo[i],
                });
              }
              newData.monitoring.push({
                deviceName: item.deviceName,
                valueList: tmpVal,
              });
            });
          }
          that.informationData = newData;
        });
    },
    getAjaxResult() {
      let that = this;
      Promise.all([that.getDynamicsEmissionSource(), that.sleep(800)]).then((values) => {
        //this.getDynamicsEmissionSource();
        try {
          that.loading2 = false;
          that.chartShowValid = true;
          that.allRenderData = [];
          that.productData.forEach((item, i) => {
            that.formatProductPower(item, i);
            that.formatProduct(item, i);
            that.formatProductVal(item, i);
          });
          that.governData.forEach((item, i) => {
            that.formatGovern(item, i);
            that.formatGovernPower(item, i);
          });
          that.beltTspData.forEach((item, i) => {
            that.formatTps(item, i);
          });

          that.asyncRender(that.allRenderData);
          /*that.$forceUpdate();
            that.$nextTick(() => {
              that.asyncRender(that.allRenderData);
            });*/

          /*that.formatGovern(values[0].governData);
            that.formatGovernPower(values[0].governData);
            that.formatTps(values[0].beltTspData);*/

          //that.$forceUpdate();
        } catch (err) {
          console.log(err);
        }
      });
    },
    changeBringins() {
      let that = this;

      this.timeArr = [
        dateFormat("YYYY-mm-dd", new Date()) + " 00:00",
        dateFormat("YYYY-mm-dd HH:MM", new Date()),
      ];
      //this.updateInventorySwitch(false);
      this.sampledataHeight = $(this.$refs.sampledata).outerHeight();
      if (that.tabName === "basicInfo") {
        this.getDeviceDetail();
      } else {
        this.getAjaxResult();
      }

      $(this.$refs.sampledata).bringins();
    },
    asyncRender(list) {
      let that = this;
      if (list.length > 0) {
        let tmpObj = list.shift();
        tmpObj.finished = true;
        this.$forceUpdate();
        this.$nextTick(() => {
          setTimeout(function () {
            that.asyncRender(list);
          }, 50);
        });
      } else {
        that.$nextTick(() => {
          //that.connectEchart();
          //that.connectChart();
          if (bmeConfig.customizeEchartConnect) {
            this.connectChart();
          } else {
            this.connectEchart();
          }
        });
      }
    },
    sleep(time = 2000) {
      return new Promise((resolve) => {
        setTimeout(function () {
          resolve("暂停");
        }, time);
      });
    },
    returnFunc() {
      if (this.allEmissionInventoryId) {
        this.allEmissionInventoryId = "";
        this.materialObj = {};
        this.shedId = "";
        this.updateAllEmissionVdmId(false);
        this.updateAllEmissionInventoryId(false);
        $(".bringins-block").fadeOut(500);
        if (this.rowClickRecover) {
          this.rowClickRecover();
        }
      } else if (this.dutyInventoryId) {
        this.dutyInventoryId = "";
        this.inventoryId = "";
        $(".bringins-block").fadeOut(500);
        if (this.rowClickRecover) {
          this.rowClickRecover();
        }
      } else {
        if (this.updateInventorySwitch) {
          this.updateInventorySwitch(false);
        }
        if (this.updateLeftRightPart) {
          this.updateLeftRightPart(false);
        }
        if (this.updateInventoryId) {
          this.updateInventoryId(false);
        }
      }
    },
    toVDMList(deviceNo) {
      this.$store.commit("dialogStatus", true);
      this.$popup.open(iframePup, this.dialogCompontent, this, {
        dialog: `${window.bmeConfig.baseUrlHttp}/standard/${window.CONFIG.requestName}/page/govern/vdm_stand.html?customerId=${this.customerId}&sourceType=1&style=${this.styleType}&deviceNoDp=${deviceNo}` +(window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : ''),
      });
    },
    // 点击启停信号
    chartsBar2ClickEvent(parmas) {
      let that = this;
      let findFogGunFileUrl = CONFIG.requestName + this.$apiOpt.findFogGunFile;
      if (parmas.seriesName == "启") {
        this.$apiUtils
          .get(findFogGunFileUrl, {
            time: parmas.time + ":00",
            deviceNo: parmas.deviceNo,
          })
          .then((data) => {
            this.showFogVideo = true;
            this.curGovernTimeValue = {
              type: data.type,
              url: data.file_name,
            };
            if (data.type == 1) {
              // video
              this.curGovernTimeValue = {
                type: data.type,
                url: require("/public/static/video/eg.mp4"),
              };
            } else if (data.type == 2) {
              // img
              this.curGovernTimeValue = {
                type: data.type,
                url: require("./img/01.png"),
              };
            } else if (data.type == 3) {
              // 未知 请联系管理员
              this.curGovernTimeValue = {
                type: "",
                url: "",
              };
            }
          })
          .catch((err) => {
            that.showFogVideo = false;
            console.log("err", err);
          });
      } else {
        that.showFogVideo = false;
      }
    },

    // 关闭启停信号视频弹窗
    hideGovernVeido() {
      this.showFogVideo = false;
    },

    // 监听滚动
    addEleListener(data) {
      if (data) {
        this.scrollview = document.getElementsByClassName("el-tabs__content");
        this.scrollview.addEventListener(
          "scroll",
          () => {
            this.scrollChange;
          },
          false
        );
      }
    },

    // 滚动监听
    scrollChange(e) {
      // console.log('父滚动条到页面顶部距离', e.target.offsetTop)
      // console.log('相对距离', this.$refs.scrollview.scrollTop)
      // console.log('绝对距离', e.target.offsetTop + this.$refs.scrollview.scrollTop)
    },
  },
  // unmounted vue3x 里面移除监听
  unmounted() {
    // 获取指定元素
    // const scrollview = this.$refs['scrollview'];
    // // 移除监听
    // scrollview.removeEventListener('scroll', this.scrollChange, true);
  },
};
</script>

<style lang="scss">
.emission {
  position: relative;
  width: 100%;
  height: 100%;

  .el-tabs__content {
    position: absolute !important;
    top: 120px !important;
    bottom: 50px !important;
    left: 50px !important;
    right: 30px !important;
    overflow: auto !important;
  }
}

.emission-content {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: url(/static/img/img_bg.png);
  background-size: 100% 100%;
  padding: 25px 25px;
  font-size: 12px;
}
.emission-content-green {
  background: url(/static/img/img_bg_green.png);
  background-size: 100% 100%;
}
.emission .el-tabs__item {
  color: #fff !important;
  font-size: 32px !important;
  line-height: 80px;
  height: 80px;
  padding: 0 30px 0 30px !important;
}

.emission .el-tabs__item.is-active {
  color: #3fad92 !important;
  font-size: 32px !important;
  line-height: 80px;
  height: 80px;
  padding: 0 30px 0 30px !important;
}

.return-btn {
  background-image: url("/static/img/return.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 160px;
  height: 50px;
  position: absolute;
  top: 26px;
  right: 50px;
  z-index: 1;
  cursor: pointer;
}

.return-btn > span {
  font-size: 30px;
  left: 80px;
  top: 6px;
  position: relative;
}

.equipType {
  font-size: 24px;
  line-height: 24px;
  color: #3fad92;
}

.title-img {
  display: inline-block;
  vertical-align: middle;
  margin-right: 15px;
}

.title span {
  font-size: 24px;
  line-height: 24px;
}

.emission-content-blue {
  .emission-content {
    background: url("/static/img/popupImg/dialogKuang_blue.png") no-repeat center center !important;
    background-size: 100% 100% !important;
  }
  .return-btn {
    width: 60px !important;
    height: 60px !important;
    background: url("/static/img/popupImg/return_default_blue.png") no-repeat center
      center;
    background-size: 100% 100%;
    &:hover {
      background-image: url("/static/img/popupImg/return_blue.png");
    }
    &:active {
      background-image: url("/static/img/popupImg/return_blue.png");
    }
  }
  .title img {
    display: none;
  }
  .emission .el-tabs__item.is-active {
    color: rgba(111, 227, 255, 1) !important;
  }

  .title span {
    color: rgba(111, 227, 255, 1) !important;
  }

  .el-form-item .el-form-item__content button {
    width: 129px;
    height: 41px;
    background: url("/static/img/popupImg/but_default.png") no-repeat center center;
    background-size: 100% 100%;
    border-radius: 4px;
    font-size: 18px;
    color: #fff;
    margin-left: 20px;
    box-shadow: none;
    border: none;
    &:hover {
      background: url("/static/img/popupImg/but.png") no-repeat center center;
      background-size: 100% 100%;
    }
  }
  .el-form-item .el-form-item__label {
    color: rgba(209, 236, 255, 1) !important;
    font-size: 20px;
    padding: 0 8px 0 0;
  }

  .el-tabs__nav-wrap::after {
    background-color: rgba($color: #fff, $alpha: 0.3);
  }
  .el-range-editor {
    border: 1px solid #3080b7 !important;
    background: linear-gradient(
      180deg,
      rgba(4, 102, 125, 0.79) 0%,
      #06435f 100%
    ) !important;
    .el-input__inner {
      color: #99f5ff !important;
      box-shadow: none !important;
      border: none;
      color: rgba(209, 236, 255, 1) !important;
    }
    .el-input__inner::-webkit-input-placeholder {
      color: rgb(74, 180, 183) !important;
    }
    .el-range-separator {
      color: #d1ecff !important;
    }
  }
  .el-form-item__content .el-date-editor,
  .el-form-item__content .el-date-editor input {
    color: #d1ecff !important;
  }
}
.cur-govern-time-vedio,
.cur-govern-time-img {
  position: absolute;
  right: 10px;
  bottom: 30px;
  height: 200px;
  width: 400px;
}
.cur-govern-time-img {
  object-fit: contain;
  img {
    width: 100%;
  }
}
.video-wrap {
  position: absolute;
  right: 10px;
  bottom: 10px;
}
</style>

<style>
.emission .emission-content .el-date-editor {
  width: 450px;
}

.VDMButton {
  font-size: 20px;
  line-height: 24px;
  border: 1px solid #00adff;
  padding: 0 10px;
  margin-left: 20px;
  border-radius: 10px;
  background: #00adff;
  cursor: pointer;
}
</style>
